import * as d3 from 'd3'

export default {
  data: () => ({
    selectedSearchOption: '',
  }),

  methods: {
    
    gmx_SearchTool(selection, _data) {
      
      let box_ = this.gmx_groupBox(selection, {
        x         : _data.x,
        y         : _data.y,
        width     : _data.width,
        height    : _data.height-.5,
        label     : _data.label,
        labelWidth: _data.labelWidth,
      })

      let margin = 15
      let inputHeight = 22
      let targetNames = _data.targets.map(t => t.text)
      let this_ = this

      // input box border -----------
      box_
      .append('rect')
      .attr('transform', `translate(${margin}, ${margin})`)
      .attr('width', _data.width - margin*2).attr('height', inputHeight)
      .attr('fill', '#fff').attr('stroke', '#dadada').attr('stroke-width', .5)
      // ----------------------------

      // ### draw search input in the search group box
      box_
      .append("foreignObject")
      .attr('x', margin).attr('y', margin)
      .attr('width', _data.width - margin*2).attr('height', inputHeight)
      .append('xhtml:div')
      .append('div')
      .attr('id', 'search_input')     // for the javascript document.getElementById
      .attr('class', 'search_input')  // for the d3 general purpose
      .attr('contentEditable', true)
      .attr('style', `padding: 2px 48px 2px 5px; font-size: 10px; line-height: 18px; text-align: left; white-space: nowrap;`)
      .on('keydown', function(event) {
        if(event.keyCode === 13){
          this_.trimDivText(d3.select(this))     
          setTimeout(() => { this_.setCaret(document.getElementById('search_input')) })
        }
        this_.register(() => { 
          let text = d3.select(this).text()
          if(text.length > 25) d3.select(this).text(text.substring(0, 24))
          _data.callFunc(text, 'search') 
        }, 500) 
      })
      .on('keyup', function(event) {
        if(event.keyCode === 13){
          this_.trimDivText(d3.select(this))
          this_.setCaret(document.getElementById('search_input'))
        }
      })

      box_
      .append('text')
      .attr('class', 'delete_search_text')
      .attr('transform', `translate(${_data.width-42}, ${margin+11 + 15*0.26})`)
      .attr('text-anchor', 'start')
      .style('font-size', 15).style('cursor', 'pointer').style('opacity', .3)
      .text('x')
      .on('mouseover', function(event) { d3.select(this).transition().duration(100).style('opacity', .7) })
      .on('mouseout', function(event) { d3.select(this).transition().duration(100).style('opacity', .3) })
      .on('click', () => { 
        d3.select(`#${this.localId}`).select('.search_input').text('')
        _data.callFunc('','search')
      })

      box_
      .append('image') 
      .attr('transform', `translate(${_data.width-32}, ${margin+5})`)
      .attr('xlink:href', require('@/assets/svg/icons/iconmonstr-magnifier-2.svg'))
      .attr('width', 12).attr('height', 12).style('cursor', 'pointer')
      .style('opacity', .3)
      .on('mouseover', function(event) { d3.select(this).transition().duration(100).style('opacity', .7) })
      .on('mouseout', function(event) { d3.select(this).transition().duration(100).style('opacity', .3) })
      // .on('click', (_, i, a) => { _data.callFunc(d3.select(a[i]).text()) })
      
      box_
      .append('text')
      .attr('transform', `translate(${margin}, ${margin+inputHeight+10 + 9*0.26})`)
      .attr('text-anchor', 'start')
      .style('font-family', 'roboto').style('font-size', 9).style('fill', '#757575')
      .text(`${targetNames.join(', ')}`)
    },


    trimDivText(selection) {
      let text = selection.html().replace(/<div(.*?)\/div>/g, '')
      selection.html(text)
    },


    setCaret(el) {
      let range = document.createRange(),
          sel = window.getSelection(),
          lastKnownIndex = -1;
      for (let i = 0; i < el.childNodes.length; i++) {
        if (this.isTextNodeAndContentNoEmpty(el.childNodes[i])) {
          lastKnownIndex = i;
        }
      }
      if (lastKnownIndex === -1) {
        // throw new Error('Could not find valid text content');
        return
      }
      let row = el.childNodes[lastKnownIndex],
      col = row.textContent.length;
      range.setStart(row, col);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
      el.focus();
    },
    
    
    isTextNodeAndContentNoEmpty(node) {
      return node.nodeType == Node.TEXT_NODE && node.textContent.trim().length > 0
    },
  }
}
